var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-container",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading"
        }
      ],
      staticClass: "bairun-absolute-container bairun-bianlidian-lirun"
    },
    [
      _c("el-header", { staticClass: "bairun-header" }, [
        _c(
          "div",
          { staticClass: "search-term" },
          [
            _c(
              "el-form",
              { attrs: { inline: true } },
              [
                _c(
                  "el-popover",
                  {
                    directives: [
                      {
                        name: "mobile",
                        rawName: "v-mobile",
                        value: true,
                        expression: "true"
                      }
                    ],
                    attrs: { placement: "right-end", trigger: "click" },
                    model: {
                      value: _vm.showSelSeller,
                      callback: function($$v) {
                        _vm.showSelSeller = $$v
                      },
                      expression: "showSelSeller"
                    }
                  },
                  [
                    _vm.sellerOptions.length > 1
                      ? _c(
                          "el-radio-group",
                          {
                            staticClass: "bairun-search-sellers",
                            attrs: { size: "mini" },
                            on: { change: _vm.onCheckTab },
                            model: {
                              value: _vm.searchInfo.sellerId,
                              callback: function($$v) {
                                _vm.$set(_vm.searchInfo, "sellerId", $$v)
                              },
                              expression: "searchInfo.sellerId"
                            }
                          },
                          [
                            _c(
                              "el-radio",
                              { attrs: { label: 0, border: "" } },
                              [_vm._v("总")]
                            ),
                            _vm._l(_vm.sellerOptions, function(item) {
                              return _c(
                                "el-radio",
                                { attrs: { label: item.sellerId, border: "" } },
                                [_vm._v(_vm._s(item.shortSellerName))]
                              )
                            })
                          ],
                          2
                        )
                      : _vm._e(),
                    _c(
                      "el-button",
                      { attrs: { slot: "reference" }, slot: "reference" },
                      [
                        _vm._v(
                          _vm._s(
                            _vm._f("getSellerShortName")(
                              _vm.searchInfo.sellerId
                            )
                          )
                        )
                      ]
                    )
                  ],
                  1
                ),
                _vm.sellerOptions.length > 1
                  ? _c(
                      "el-radio-group",
                      {
                        directives: [
                          {
                            name: "mobile",
                            rawName: "v-mobile",
                            value: false,
                            expression: "false"
                          }
                        ],
                        staticClass: "bairun-search-sellers",
                        attrs: { size: "mini" },
                        on: { change: _vm.onCheckTab },
                        model: {
                          value: _vm.searchInfo.sellerId,
                          callback: function($$v) {
                            _vm.$set(_vm.searchInfo, "sellerId", $$v)
                          },
                          expression: "searchInfo.sellerId"
                        }
                      },
                      [
                        _c("el-radio", { attrs: { label: 0, border: "" } }, [
                          _vm._v("总")
                        ]),
                        _vm._l(_vm.sellerOptions, function(item) {
                          return _c(
                            "el-radio",
                            { attrs: { label: item.sellerId, border: "" } },
                            [_vm._v(_vm._s(item.shortSellerName))]
                          )
                        })
                      ],
                      2
                    )
                  : _vm._e(),
                _vm.searchInfo.timeTag !== "custom"
                  ? _c(
                      "div",
                      [
                        _c("el-date-picker", {
                          attrs: {
                            type: "date",
                            format: "yyyy-MM-dd",
                            "value-format": "yyyy-MM-dd 00:00:00",
                            placeholder: "日期选择",
                            clearable: false
                          },
                          on: { change: _vm.onCheckTab },
                          model: {
                            value: _vm.searchInfo.dateTime,
                            callback: function($$v) {
                              _vm.$set(_vm.searchInfo, "dateTime", $$v)
                            },
                            expression: "searchInfo.dateTime"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.searchInfo.timeTag === "custom"
                  ? _c(
                      "div",
                      [
                        _c("el-date-picker", {
                          attrs: {
                            type: "date",
                            format: "yyyy-MM-dd",
                            "value-format": "yyyy-MM-dd 00:00:00",
                            placeholder: "日期选择",
                            clearable: false
                          },
                          on: { change: _vm.onCheckTab },
                          model: {
                            value: _vm.searchInfo.startTime,
                            callback: function($$v) {
                              _vm.$set(_vm.searchInfo, "startTime", $$v)
                            },
                            expression: "searchInfo.startTime"
                          }
                        }),
                        _vm._v("- "),
                        _c("el-date-picker", {
                          attrs: {
                            type: "date",
                            format: "yyyy-MM-dd",
                            "value-format": "yyyy-MM-dd 23:59:59",
                            placeholder: "日期选择",
                            clearable: false,
                            "picker-options": _vm.endTimePickerOptions
                          },
                          on: { change: _vm.onCheckTab },
                          model: {
                            value: _vm.searchInfo.endTime,
                            callback: function($$v) {
                              _vm.$set(_vm.searchInfo, "endTime", $$v)
                            },
                            expression: "searchInfo.endTime"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "el-radio-group",
                  {
                    attrs: { size: "mini" },
                    on: { change: _vm.onCheckTime },
                    model: {
                      value: _vm.searchInfo.timeTag,
                      callback: function($$v) {
                        _vm.$set(_vm.searchInfo, "timeTag", $$v)
                      },
                      expression: "searchInfo.timeTag"
                    }
                  },
                  [
                    _c("el-radio-button", { attrs: { label: "date" } }, [
                      _vm._v("当日")
                    ]),
                    _c("el-radio-button", { attrs: { label: "week" } }, [
                      _vm._v("当周")
                    ]),
                    _c("el-radio-button", { attrs: { label: "month" } }, [
                      _vm._v("当月")
                    ]),
                    _c("el-radio-button", { attrs: { label: "year" } }, [
                      _vm._v("当年")
                    ]),
                    _c("el-radio-button", { attrs: { label: "custom" } }, [
                      _vm._v("自定义")
                    ])
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _c("el-main", { staticClass: "bairun-main" }, [
        _c("div", { staticClass: "bairun-padding" }, [
          _c(
            "div",
            { staticClass: "divider-title" },
            [
              _c(
                "el-radio-group",
                {
                  attrs: { size: "mini" },
                  on: { change: _vm.onCheckTab },
                  model: {
                    value: _vm.checkTab,
                    callback: function($$v) {
                      _vm.checkTab = $$v
                    },
                    expression: "checkTab"
                  }
                },
                [
                  _c("el-radio-button", { attrs: { label: "seller" } }, [
                    _vm._v("站点")
                  ]),
                  _c("el-radio-button", { attrs: { label: "sku" } }, [
                    _vm._v("商品")
                  ])
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.checkTab === "seller",
                  expression: "checkTab === 'seller'"
                }
              ],
              staticClass: "bairun-margin-t"
            },
            [
              _c(
                "el-table",
                {
                  ref: "lirunTable",
                  staticStyle: { width: "100%" },
                  attrs: {
                    data: _vm.lirunTable.table,
                    "show-summary": "",
                    "summary-method": _vm.getSellerSummaries,
                    "default-sort": { prop: "grossProfit", order: "descending" }
                  }
                },
                [
                  _c("el-table-column", {
                    attrs: { label: "便利店", prop: "sellerName" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c("div", [_vm._v(_vm._s(scope.row.sellerName))])
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: { label: "实收", prop: "tradeAmount" }
                  }),
                  _c("el-table-column", {
                    attrs: { label: "成本", prop: "goodsCosts" }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "实收毛利",
                      prop: "grossProfit",
                      sortable: ""
                    }
                  }),
                  _c("el-table-column", {
                    attrs: { label: "实收毛利率", prop: "grossMargin" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c("div", [
                              _vm._v(
                                _vm._s(
                                  (scope.row.grossMargin * 100).toFixed(2)
                                ) + "%"
                              )
                            ])
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.checkTab === "sku",
                  expression: "checkTab === 'sku'"
                }
              ],
              staticClass: "bairun-margin-t"
            },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "mobile",
                      rawName: "v-mobile",
                      value: false,
                      expression: "false"
                    }
                  ],
                  staticClass: "search-spu",
                  staticStyle: { width: "370px" }
                },
                [
                  _c(
                    "el-input",
                    {
                      attrs: { placeholder: "输入商品名称", clearable: "" },
                      model: {
                        value: _vm.searchInfo.goodsName,
                        callback: function($$v) {
                          _vm.$set(_vm.searchInfo, "goodsName", $$v)
                        },
                        expression: "searchInfo.goodsName"
                      }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "150px" },
                          attrs: {
                            slot: "prepend",
                            placeholder: "选择商品组",
                            clearable: "",
                            filterable: ""
                          },
                          on: { change: _vm.onCheckTab },
                          slot: "prepend",
                          model: {
                            value: _vm.searchInfo.spuNoStr,
                            callback: function($$v) {
                              _vm.$set(_vm.searchInfo, "spuNoStr", $$v)
                            },
                            expression: "searchInfo.spuNoStr"
                          }
                        },
                        _vm._l(_vm.searchSpuGroupOptions, function(item) {
                          return _c("el-option", {
                            attrs: {
                              label: item.spuGroupName,
                              value: item.spuNoStr
                            }
                          })
                        }),
                        1
                      ),
                      _c("el-button", {
                        attrs: { slot: "append", icon: "el-icon-search" },
                        on: { click: _vm.onCheckTab },
                        slot: "append"
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "mobile",
                      rawName: "v-mobile",
                      value: true,
                      expression: "true"
                    }
                  ],
                  staticClass: "search-spu",
                  staticStyle: { "margin-right": "16px" }
                },
                [
                  _c(
                    "el-input",
                    {
                      attrs: { placeholder: "输入商品名称", clearable: "" },
                      model: {
                        value: _vm.searchInfo.goodsName,
                        callback: function($$v) {
                          _vm.$set(_vm.searchInfo, "goodsName", $$v)
                        },
                        expression: "searchInfo.goodsName"
                      }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "130px" },
                          attrs: {
                            slot: "prepend",
                            placeholder: "选择商品组",
                            clearable: "",
                            filterable: ""
                          },
                          on: { change: _vm.onCheckTab },
                          slot: "prepend",
                          model: {
                            value: _vm.searchInfo.spuNoStr,
                            callback: function($$v) {
                              _vm.$set(_vm.searchInfo, "spuNoStr", $$v)
                            },
                            expression: "searchInfo.spuNoStr"
                          }
                        },
                        _vm._l(_vm.searchSpuGroupOptions, function(item) {
                          return _c("el-option", {
                            attrs: {
                              label: item.spuGroupName,
                              value: item.spuNoStr
                            }
                          })
                        }),
                        1
                      ),
                      _c("el-button", {
                        attrs: { slot: "append", icon: "el-icon-search" },
                        on: { click: _vm.onCheckTab },
                        slot: "append"
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-button",
                {
                  staticClass: "right bairun-margin-l",
                  attrs: {
                    type: "primary",
                    size: "mini",
                    icon: "el-icon-download"
                  },
                  on: { click: _vm.onDownload }
                },
                [_vm._v("下载")]
              ),
              _c(
                "el-table",
                {
                  ref: "skuTable",
                  staticStyle: { width: "100%" },
                  attrs: {
                    data: _vm.lirunSkuTable.table,
                    height: "48rem",
                    "show-summary": "",
                    "summary-method": _vm.getSkuSummaries
                  },
                  on: { "filter-change": _vm.onSearchByCategory }
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.lirunSkuTable.categoryColumn,
                      prop: "categoryName",
                      "filter-multiple": false,
                      filters: _vm.lirunSkuTable.category,
                      "column-key": "categoryNo"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c("div", [_vm._v(_vm._s(scope.row.categoryName))])
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: { label: "商品", prop: "goodsName" }
                  }),
                  _c("el-table-column", {
                    attrs: { label: "订单", prop: "totalOrderNum" }
                  }),
                  _c("el-table-column", {
                    attrs: { label: "销量(个)", prop: "totalGoodsNum" }
                  }),
                  _c("el-table-column", {
                    attrs: { label: "应收(元)", prop: "totalOrderSaleAmount" }
                  }),
                  _c("el-table-column", {
                    attrs: { label: "优惠(元)", prop: "totalOrderDiscount" }
                  }),
                  _c("el-table-column", {
                    attrs: { label: "实收(元)", prop: "totalTradePay" }
                  }),
                  _c("el-table-column", {
                    attrs: { label: "成本(元)", prop: "totalGoodsCost" }
                  }),
                  _c("el-table-column", {
                    attrs: { label: "实收毛利(元)", prop: "grossProfit" }
                  }),
                  _c("el-table-column", {
                    attrs: { label: "实收毛利率" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c("div", [
                              _vm._v(
                                _vm._s(
                                  (scope.row.grossMargin * 100).toFixed(2)
                                ) + "%"
                              )
                            ])
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              ),
              _c("el-pagination", {
                style: { float: "right", padding: "20px" },
                attrs: {
                  small: "",
                  "hide-on-single-page": false,
                  "pager-count": 5,
                  "current-page": _vm.lirunSkuTable.page,
                  "page-size": _vm.lirunSkuTable.pageSize,
                  total: _vm.lirunSkuTable.total,
                  layout: "total, prev, pager, next"
                },
                on: {
                  "current-change": _vm.handleSkuCurrentChange,
                  "size-change": _vm.handleSkuSizeChange
                }
              })
            ],
            1
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }